import { LocationStrategy } from "@angular/common";
import { AfterViewInit, Component, ComponentFactoryResolver, EventEmitter, Input, Output, ViewChild, ViewContainerRef } from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { AppService } from "@api";
import { MensajeService } from "@mensaje/Mensaje.Service";
import { PeriodoEvaluacion } from "@modelo/proceso/periodoevaluacion.model";
import { TranslateService } from "@ngx-translate/core";
import { SistemaService } from "@servicios/Sistema.Service";
import { AsignacionEvaluacionTallerAlumnoComponent } from "./asignacionevaluaciontalleresseccion/asignacionevaluaciontaller_alumno.component";
import { RespuestaEstatusEnum } from "@enumeraciones/Enumeraciones.enum";
import { AsignacionEvaluacionTallerPadreComponent } from "./asignacionevaluaciontalleresseccion/asignacionevaluaciontaller_padre.component";


@Component({
    selector: 'asignacionevaluaciontaller',
    templateUrl: './asignacionevaluaciontaller.component.html',
})

export class AsignacionEvaluacionTallerComponent implements AfterViewInit{
    consulta!:boolean;
    public errorActivo!: boolean;
    entidad: PeriodoEvaluacion;
    @ViewChild('general') private asignaciongeneralComponent!: AsignacionEvaluacionTallerAlumnoComponent;
    @ViewChild('secundario') private asignacionsecundarioComponent!: AsignacionEvaluacionTallerPadreComponent;
    @ViewChild('tab') private tab!: MatTabGroup;
    @Input() accion!: {accion: string, entidad:any};
    @Input() id!: number;
    @Input() identificador!: number;
    @Output() output = new EventEmitter();
    cambio: boolean = false;
    visualizar: boolean = false;
    tipoGuardado:number = 0;

    @ViewChild("asignacionevaluaciontalleralumno", {read: ViewContainerRef}) asignacionevaluaciontalleralumno!: ViewContainerRef;
    @ViewChild("asignacionevaluaciontallerpadre", {read: ViewContainerRef}) asignacionevaluaciontallerpadre!: ViewContainerRef;

    constructor(private appService: AppService,private location: LocationStrategy, public sistemaService: SistemaService, public translate: TranslateService, private mensajeService: MensajeService, public _cfr: ComponentFactoryResolver){
        this.entidad = new PeriodoEvaluacion();
        history.pushState(null, "", window.location.href);
        this.location.onPopState(() => {
            this.Salir();
        });
    }

    ngAfterViewInit(){
        if (this.identificador == 2) {
            this.visualizar = true;
        }
        this.SetPeriodoEvaluacion();
        // 1. Save the click handler for later
        const handleTabClick = this.tab._handleClick;
        // 2. Replace the click handler with our custom function
        this.tab._handleClick = (tab, header, index) => {
            switch (this.tab.selectedIndex) {
                case 0:
                    this.tipoGuardado = 1;
                    break;
                case 1:
                    this.tipoGuardado = 2;
                    break;
                case 2:
                case 3:
            }

        };
    }

    SetPeriodoEvaluacion(){
        this.appService.Post("planeacion/periodoevaluacion/buscar", {"periodoevaluacionid":this.id}).then(res=>{
            if(res.status == RespuestaEstatusEnum.Success){
                this.entidad = new PeriodoEvaluacion(res.data[0]);
                this.asignaciongeneralComponent.cicloid = res.data[0].cicloid;
                this.asignaciongeneralComponent.SetTallerAlumno();
                this.asignacionsecundarioComponent.cicloid = res.data[0].cicloid;
                this.asignacionsecundarioComponent.setTallerPadre();
            }
        })
    }

    Guardar(){
      if(this.tab.selectedIndex == 1){
        this.asignacionsecundarioComponent.Guardar();
      }else if(this.tab.selectedIndex == 0){
        this.asignaciongeneralComponent.Guardar();
      }
    }

    Salir(){
        this.output.next(this.cambio);
    }
}